var _rect, _polyline, _polyline2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCaretDoubleRight = function SvgCaretDoubleRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    fill: "#fcfcfc",
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "56 48 136 128 56 208",
    fill: "none",
    stroke: "#fcfcfc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "136 48 216 128 136 208",
    fill: "none",
    stroke: "#fcfcfc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 16
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCaretDoubleRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caret-double-right.8510beec.svg";
export { ForwardRef as ReactComponent };